import luDragSelect from "./src/lu-drag-select";

luDragSelect.install = function(Vue) {
  Vue.component(luDragSelect.name, luDragSelect);
};

export default luDragSelect;
